<template>
  <el-drawer
    :visible.sync="drawer"
    :append-to-body="true"
    :modal="false"
    direction="rtl"
    size="400px">
    <span slot="title">
      订单详情
      <span class="normal ml10">订单号：{{ orderList.record_code }}</span>
    </span>
    <!-- 商品信息 -->
    <div class="green-title-normal">
      <i></i>
      <span>商品信息</span>
    </div>
    <div class="item">
      <span class="text-right normal-span">系统类型</span>：
      <span class="text-left">{{orderList.shop_type | formatSysType(orderList.is_producer)}}</span>
    </div>
    <div class="item" >
      <span style="width: 110px">购买服务/商品</span>：
      <span class="text-left">{{orderList.goods_item}}</span>
    </div>
    <template v-if="isComposeGoods">
      <div class="item">
        <span class="text-right normal-span">单价</span>：
        <span class="text-left">{{(orderList.total_price / orderList.count / orderList.portion_number) | mathFloat}}元/{{isStaff ? '个' : '套'}}/年</span>
      </div>
      <div class="item">
        <span class="text-right normal-span">数量</span>：
        <span class="text-left">{{orderList.portion_number}}</span>
      </div>
      <div class="item">
        <span class="text-right normal-span">购买时长</span>：
        <span class="text-left">{{orderList.count}}年</span>
      </div>
    </template>
    <template v-else-if="isNewLsStaffSeat">
      <div class="item">
        <span class="text-right normal-span">单价</span>：
        <span class="text-left">{{(orderList.total_price / orderList.count) | mathFloat}}元/个</span>
      </div>
      <div class="item">
        <span class="text-right normal-span">数量</span>：
        <span class="text-left">{{orderList.count}}个</span>
      </div>
      <div class="item">
        <span class="text-right normal-span">有效期</span>：
        <span class="text-left">1年</span>
      </div>
    </template>
    <template v-else>
      <div class="item">
        <span class="text-right normal-span">单价</span>：
        <span v-if="isNewLsCashierPart" class="text-left">{{ orderList.count ? orderList.total_price / orderList.count : 0}}元/位</span>
        <span v-else-if="isNewLsAnnualFee" class="text-left">{{ orderList.count > 0 ? orderList.total_price / orderList.count : +(orderList.total_price / orderList.expired_date_ls * 365).toFixed(2) }}元/年</span>
        <span v-else-if="orderList.expired_date === 1" class="text-left">{{orderList.total_price / orderList.count}}</span>
        <span v-else class="text-left">{{(orderList.total_price / orderList.count) | formatMoneyToYear}}</span>
      </div>
      <div class="item" v-if="orderList.count !== 0 && (isNewLsAnnualFee || isNewLsCashierPart)">
        <span class="text-right normal-span">数量</span>：
        <span class="text-left">{{orderList.count === 0 ? 0 : orderList.count }}</span>
      </div>
      <div class="item" v-if="!isNewLsAnnualFee">
        <span class="text-right normal-span">有效期：</span>
        <span class="text-left">{{orderList.expired_date | formatExpired}}</span>
      </div>
      <div class="item" v-if="isNewLsAnnualFee">
        <span class="text-right normal-span">购买时长</span>：
        <span class="text-left">{{ orderList.count > 0 ? orderList.count + '年': orderList.expired_date_ls + '天'}}</span>
      </div>
    </template>

    <div class="item" v-if="orderList.discount_percent">
      <span class="text-right normal-span">限时{{ orderList.discount_percent }}折</span>：
      <span class="text-left red-money">-￥{{ +orderList.discount_price }}</span>
    </div>
    <div class="item" v-if="orderList.deduction_price">
      <span class="text-right normal-span">抵扣金额</span>：
      <span class="text-left">-￥{{ +orderList.deduction_price}}
        <el-tooltip effect="dark"
            placement="top-start">
            <div slot="content" style="line-height: 18px">
                <p>{{ orderList.deduction_content}}</p>
            </div>
            <i class="question-icon"/>
        </el-tooltip>
      </span>
    </div>
    <div class="item" v-if="orderList.remark">
      <span class="text-right normal-span">备注</span>：
      <span class="text-left">{{ orderList.remark }}</span>
    </div>
     <div class="item coupon-item" v-if="orderList.coupon_price > 0">
      <span class="text-right normal-span">优惠金额</span>：
      <span class="text-lef">￥{{ +orderList.coupon_price}}</span>
    </div>
    <div class="item pay-item">
      <span class="text-right normal-span">应付款</span>：
      <span class="text-lef money ">￥{{ +orderList.pay_money}}</span>
    </div>
    
    <!-- 付款信息 -->
    <div class="green-title-normal mtop20">
      <i></i>
      <span>付款信息</span>
    </div>
    <div class="item">
      <span class="text-right normal-span">付款金额</span>：
      <span class="text-left">{{orderList.pay_money | formatMoney}}</span>
    </div>
    <div class="item">
      <span class="text-right normal-span">付款方式</span>：
      <span class="text-left">{{ getPaymentText(orderList) }}</span>
    </div>
    <div class="item" v-if="isManualPayment">
      <span class="text-right normal-span common-head-text">付款人</span>：
      <span class="text-left common-head-text">{{ orderList.payer_name || '-' }}</span>
    </div>
    <div class="item" v-else>
      <span class="text-right normal-span common-head-text">付款人</span>：
      <img
        :src="orderList.avatar"
        class="common-head-img"
        :class="orderList.sex === 1? 'man-border': 'wowan-border'"
      />
      <span class="text-left common-head-text">{{orderList.nickname}}</span>
    </div>
    <!-- 订单信息 -->
    <div class="green-title-normal mtop20">
      <i></i>
      <span>订单信息</span>
    </div>
    <div class="item">
      <span class="text-right normal-span">创建时间</span>：
      <span class="text-left">{{orderList.create_time}}</span>
    </div>
    <div class="item">
      <span class="text-right normal-span">完成时间</span>：
      <span class="text-left">{{orderList.pay_time}}</span>
    </div>
    <div class="item">
      <span class="text-right normal-span">交易单号</span>：
      <span class="text-left">{{ getTradeNoText(orderList) }}</span>
    </div>
  </el-drawer>
</template>

<script>
import { mathFloat } from '@senguo/senguo-lodash'
import { 
  checkFeeInfo, 
  PF_SELF_SERVICE_PART,
  PF_SELF_SERVICE_ANNUAL_FEE,
  NEW_LS_CASHIER_PART,
  NEW_LS_ANNUAL_FEE,
  PF_STAFF_NUM,
  NEW_LS_STAFF_SEAT
 } from '../const'

export default {
  data() {
    return {
      drawer: false, // drawer的显示与隐藏
      orderList: {
      } // 订单列表
    };
  },
  computed: {
    isNewLsStaffSeat() {
      return checkFeeInfo(this.orderList.fee_code, [NEW_LS_STAFF_SEAT])
    },
      // hack：规格同时包含时间和数量的商品
    isComposeGoods() {
      if (!this.orderList.fee_code) return
      return checkFeeInfo(this.orderList.fee_code, [PF_SELF_SERVICE_PART, PF_SELF_SERVICE_ANNUAL_FEE, PF_STAFF_NUM])
    },
    isStaff() {
        return checkFeeInfo(this.orderList.fee_code, [PF_STAFF_NUM])
    },
    isNewLsCashierPart() {
      return checkFeeInfo(this.orderList.fee_code, NEW_LS_CASHIER_PART)
    },
    isNewLsAnnualFee() {
      return checkFeeInfo(this.orderList.fee_code, NEW_LS_ANNUAL_FEE)
    },
    isManualPayment() {
      return Number(this.orderList.payment_source_type || 0) === 2
    }
  },
  filters: {
    /**
     * 系统类型的转换
     */
    formatSysType(value, isProducer) {
      if (isProducer === 1) {
        return '产地通'
      }
      switch (value) {
        case "ph":
          return "配货";
        case "pf":
          return "批发";
        case "new_ls":
          return "新零售";
        case "wsc":
          return "微商城";
        case "old_ls":
          return "老零售";
        default:
          return "";
      }
    },
    /**
     * 把价格转换成保留小数点后两位
     */
    formatMoney(value) {
      return `￥${mathFloat(value)}`
    },
    formatMoneyToYear(value) {
      return `￥${mathFloat(value)}/年`
    },
    mathFloat,
    /**
     * 有效期，0：一年，1：永久
     */
    formatExpired(value) {
      switch (value) {
        case 0:
          return "一年";
        case 1:
          return "永久";
        default:
          return "";
      }
    },
    /**
     * 付款方式，0：支付宝
     */
    formatPayment(value) {
      switch (value) {
        case 0:
          return "支付宝";
				case 1:
          return '微信';
        default:
          return "-";
      }
    }
  },
  methods: {
    getPaymentText(orderList = {}) {
      if (orderList.pay_type_text || orderList.payment_method_text) {
        return orderList.pay_type_text || orderList.payment_method_text;
      }
      return this.$options.filters.formatPayment(orderList.pay_type);
    },
    getTradeNoText(orderList = {}) {
      if (Number(orderList.payment_source_type || 0) === 2 && !orderList.pay_order_number) {
        return "人工收款无交易单号";
      }
      return orderList.pay_order_number || "-";
    },
    show(orderList) {
      this.orderList = orderList;
      this.drawer = true;
    },
    close() {
      this.drawer = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__body {
  padding: 20px 12px;
}

.mtop20 {
  margin-top: 20px;
}

.normal {
  font-size: 14px;
  line-height: 20px;
  font-family: PingFangSC-Regular;
  color: #666;
}

.ml10 {
  margin-left: 10px;
}

.green-title-normal {
  margin-bottom: 12px;
}

.item {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  font-family: PingFangSC-Regular;
  color: #333;

  span {
    &:nth-of-type(1) {
      width: 70px;
      text-align-last: justify;
    }
  }
  .text-right {
    display: inline-block;
  }
  .tetx-left {
    text-align: left;
  }

  .red-money {
    color: #FF0000;
  }
}

.pay-item {
  font-weight: bold;

  .money {
    color: #08A681;
  }
}
.green-title-normal {
  line-height: 20px;
  height: 20px;

  i {
    display: inline-block;
    width: 4px;
    height: 20px;
    margin-right: 4px;
    border-radius: 3px;
    background: $themeColor;
  }
  
  span {
    font-size: 14px;
    font-weight: bolder;
    vertical-align: top;
  }


}

.question-icon {
  line-height: 1;
  font-size: 12px;
  color: #fff;
  margin-left: 4px;

  &::before {
      content: '?';
      display: inline-block;
      width: 15px;
      height: 15px;
      line-height: 15px;
      text-align: center;
      font-weight: normal;
      background: #d0d0d0;
      border-radius: 50%;
  }
}
.coupon-item {
  .text-lef {
    font-weight: bold;
    color: #FF5A12;
  }
}
</style>
